import React, { Fragment, useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
import { AppBar, Button, colors, Container, CssBaseline, Hidden, Paper, Toolbar } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import { insh } from "../../../../Context/InshSt";
import PrintIcon from "@material-ui/icons/Print";
import TransformIcon from "@material-ui/icons/Transform";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import {
    ArrowDownward,
    Delete,
    MoreVert,
    PersonAddRounded,
    RestaurantMenu,
} from "@material-ui/icons";
import Switch from "@material-ui/core/Switch";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PostAddIcon from "@material-ui/icons/PostAdd";
import AddBoxIcon from "@material-ui/icons/AddBox";
import StopIcon from "@material-ui/icons/Stop";
import { StyledMenu, StyledMenuItem } from '../../../../St/comps/UseStyle';

export default function InvoiceOilAppBar(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        backHome,
        handOpenDw,
        isHedden,
        permistionInv,
        style,
        stElemnt,
        clasBA,
        switchState,
        handCOpenCu,
        TransitionUp,
        transForm,
        handOpenDwt,
        handNewInv,
        HomeBcode,
        TransitionDown,
        styBtn,
        isDialog,
        toWhere,
        loading,
        buttonClassnameSave,
        success,
        clasCAB,
        or,
        isOpenPay,
        clickOpenTogglePrint,
        buttonClassnamePrint,
        clickCloseToggle,
        toPrint,
        toggle
    } = props;
    const clasup = useStylesUp();
    const [styles, setStyles] = useState(insh.bascData);
    let isSave = permistionInv?.ISSAVE == null ? true : permistionInv?.ISSAVE;

    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    return (
        <React.Fragment>
            <CssBaseline />
            <AppBar
                position="fixed"
                color="primary"
                style={{ ...style.bgImg, ...stElemnt.all.appBarBA, direction: "ltr" }}
            >
                <Toolbar className={clasBA.ToolbarBA} variant="dense">

                    <StyledMenu
                        id="customized-menu"
                        anchorEl={toggle}
                        keepMounted
                        open={Boolean(toggle)}
                        onClose={clickCloseToggle}


                        style={stElemnt.itemHigh}
                    >
                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={
                                    or.postput == "toPost"
                                        ? isSave === false ? true : false
                                        : loading.print || loading.save
                                }
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 1)}
                            >
                                <ListItemIcon>
                                    <PrintIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("cashier-view")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>

                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={
                                    or.postput == "toPost"
                                        ? isSave === false ? true : false
                                        : loading.print || loading.save
                                }
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 2)}
                            >
                                <ListItemIcon>
                                    <ScannerIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("great-view")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>
                    </StyledMenu>




                    <Hidden smUp={["sm"]}>
                        {isDialog == true ? (
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="backH"
                                onClick={props.onClose}
                            >
                                <CloseIcon />
                            </IconButton>) :
                            (
                                <div>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="backH"
                                        onClick={backHome}
                                    >
                                        <CloseIcon />
                                    </IconButton>


                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="searsh"
                                        disabled={!permistionInv.Se}
                                        onClick={() => handOpenDw(TransitionDown)}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        disabled={!permistionInv.Ne}
                                        aria-label="handNew"
                                        onClick={handNewInv}
                                    >
                                        <AddBoxIcon />
                                    </IconButton>

                                </div>)}

                    </Hidden>

                    <Hidden only={["xs"]}>
                        {isDialog === true ? (
                            <Button
                                style={styBtn.undis}
                                startIcon={<CloseIcon />}
                                onClick={props.onClose}
                            >

                                خروج
                            </Button>
                        ) : (
                            <div>
                                <Button
                                    style={styBtn.undis}
                                    onClick={backHome}
                                    startIcon={<CloseIcon />}
                                >
                                    خروج
                                </Button>

                                <Button
                                    style={!permistionInv.Se ? styBtn.dis : styBtn.undis}
                                    disabled={!permistionInv.Se}
                                    onClick={() => handOpenDwt(TransitionDown)}
                                    startIcon={<StopIcon />}
                                >
                                    {transForm("out-billing")}
                                </Button>

                                <Button
                                    style={!permistionInv.Se ? styBtn.dis : styBtn.undis}
                                    disabled={!permistionInv.Se}
                                    onClick={() => handOpenDw(TransitionDown)}
                                    startIcon={<SearchIcon />}
                                >
                                    {transForm("invoice-search")}
                                </Button>


                                <Button
                                    style={!permistionInv.Ne ? styBtn.dis : styBtn.undis}
                                    disabled={!permistionInv.Ne}
                                    onClick={handNewInv}
                                    startIcon={<AddBoxIcon />}
                                >
                                    {transForm("new")}
                                </Button>
                            </div>)}
                    </Hidden>
                    <div className={clasBA.growBA} />

                    {isOpenPay &&
                        (
                            <>
                                <Hidden smUp={["sm"]}>

                                    {or.postput === "toPost" ? (
                                        <div className={clasCAB.wrapperCAB}>
                                            <Fab
                                                size="medium"
                                                color="primary"
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                onClick={(event) => clickOpenTogglePrint(event)}

                                                disabled={
                                                    or.postput == "toPost"
                                                        ? isSave === false ? true : false
                                                        : loading.print || loading.save
                                                }

                                            >
                                                <PrintIcon />
                                            </Fab>
                                        </div>
                                    ) : (
                                        <div className={clasCAB.wrapperCAB}>

                                            <Fab
                                                size="medium"
                                                color="primary"
                                                disabled={
                                                    or.postput == "toPost"
                                                        ? isSave === false ? true : false
                                                        : loading.print || loading.save
                                                }
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                onClick={(event) => clickOpenTogglePrint(event)}

                                            >
                                                <PrintIcon />
                                            </Fab>
                                        </div>
                                    )}
                                    <div className={clasCAB.wrapperCAB}>
                                        {or.postput === "toPost" ? (
                                            <Fab
                                                size="medium"
                                                color="primary"
                                                disabled={isSave === false ? true :
                                                    or.postput == "toPost"
                                                        ? false
                                                        : loading.print || loading.save
                                                }
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                className={buttonClassnameSave}
                                                onClick={() => toWhere("save", "e")}
                                            >
                                                {" "}
                                                {success.save ? <CheckIcon /> : <SaveIcon />}
                                            </Fab>
                                        ) : (
                                            <Fab
                                                size="medium"
                                                color="primary"
                                                disabled={
                                                    permistionInv.Up == true
                                                        ? false
                                                        : loading.print || loading.save
                                                }
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                className={buttonClassnameSave}
                                                onClick={() => toWhere("save", "e")}
                                            >
                                                {" "}
                                                {success.save ? <CheckIcon /> : <SaveIcon />}
                                            </Fab>
                                        )}

                                        {(loading.print || loading.save) && (
                                            <CircularProgress
                                                size={56}
                                                className={clasCAB.fabProgressCAB}
                                            />
                                        )}
                                    </div>
                                </Hidden>

                                <Hidden only={["xs"]}>
                                    {permistionInv.Up ? (
                                        <Fragment>
                                            <div className={clasCAB.wrapperCAB}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    className={buttonClassnamePrint}
                                                    startIcon={<ScannerIcon />}
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    disabled={
                                                        or.postput == "toPost"
                                                            ? isSave === false ? true : false
                                                            : loading.print || loading.save
                                                    }
                                                    // disabled={loading.print || loading.save}
                                                    onClick={() => toPrint("print", "e", 2)}
                                                >
                                                    {transForm("great-view")}
                                                </Button>
                                                {(loading.print || loading.save) && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={clasCAB.buttonProgressCAB}
                                                    />
                                                )}
                                            </div>
                                            <div className={clasCAB.wrapperCAB}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    className={buttonClassnamePrint}
                                                    startIcon={<PrintIcon />}
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    disabled={
                                                        or.postput == "toPost"
                                                            ? isSave === false ? true : false
                                                            : loading.print || loading.save
                                                    }
                                                    // disabled={loading.print || loading.save}
                                                    onClick={() => toPrint("print", "e", 1)}
                                                >
                                                    {transForm("cashier-view")}
                                                </Button>
                                                {(loading.print || loading.save) && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={clasCAB.buttonProgressCAB}
                                                    />
                                                )}
                                            </div>

                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <div className={clasCAB.wrapperCAB}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    className={buttonClassnamePrint}
                                                    startIcon={<ScannerIcon />}
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    //  disabled={loading.print || loading.save}
                                                    disabled={
                                                        or.postput == "toPost"
                                                            ? isSave === false ? true : false
                                                            : loading.print || loading.save
                                                    }
                                                    onClick={() => toPrint("print", "e", 2)}
                                                >
                                                    {transForm("great-view")}
                                                </Button>
                                                {(loading.print || loading.save) && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={clasCAB.buttonProgressCAB}
                                                    />
                                                )}
                                            </div>

                                            <div className={clasCAB.wrapperCAB}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    className={buttonClassnamePrint}
                                                    startIcon={<PrintIcon />}
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    //disabled={loading.print || loading.save}
                                                    disabled={
                                                        or.postput == "toPost"
                                                            ? isSave === false ? true : false
                                                            : loading.print || loading.save
                                                    }
                                                    onClick={() => toPrint("print", "e", 1)}
                                                >
                                                    {transForm("cashier-view")}
                                                </Button>
                                                {(loading.print || loading.save) && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={clasCAB.buttonProgressCAB}
                                                    />
                                                )}
                                            </div>

                                        </Fragment>
                                    )}
                                    <div className={clasCAB.wrapperCAB}>
                                        {or.postput == "toPost" ?
                                            (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    className={buttonClassnameSave}
                                                    disabled={isSave === false ? true :
                                                        loading.print ||
                                                        loading.save ||
                                                        (or.postput == "toPost" ? false : true)

                                                    }
                                                    onClick={() => toWhere("save", "e")}
                                                    startIcon={<SaveIcon />}
                                                >
                                                    {transForm("save-out-print")}
                                                </Button>
                                            ) : (
                                                (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="large"
                                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                        className={buttonClassnameSave}
                                                        disabled={
                                                            loading.print ||
                                                            loading.save ||
                                                            (permistionInv.Up ? false : true)

                                                        }
                                                        onClick={() => toWhere("save", "e")}
                                                        startIcon={<SaveIcon />}
                                                    >
                                                        {transForm("save-out-print")}
                                                    </Button>
                                                )
                                            )}
                                        {(loading.print || loading.save) && (
                                            <CircularProgress
                                                size={24}
                                                className={clasCAB.buttonProgressCAB}
                                            />
                                        )}
                                    </div>
                                </Hidden>
                            </>
                        )}


                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}